export const nomes = {
  total_excesso: '1. Excesso',
  total_adequado: '2. Adequado',
  total_baixa_exposicao: '3. Baixa Exposição a Ruptura',
  total_elevada_exposicao: '4. Elevada Exposição a Ruptura',
  total_ruptura: '5. Em Ruptura'
}

export const cores = {
  total_adequado: 'rgba(0, 174, 81, 1)',
  total_excesso: 'rgba(4, 35, 51, 0.9)',
  total_baixa_exposicao: 'rgba(255, 254, 2, 1)',
  total_elevada_exposicao: 'rgba(255, 191, 5, 1)',
  total_ruptura: 'rgba(253, 0, 1, 1)',
}
